import Loadable from 'components/Loadable';
import { ROLES } from 'models/Roles';
import { IRoute } from 'models/route';
import { lazy } from 'react';

const GuidesList = Loadable(
	lazy(() => import('modules/CultureCard/pages/GuidesList')),
);

const CategoriesList = Loadable(
	lazy(() => import('modules/CultureCard/pages/CategoriesList')),
);

const CardsList = Loadable(
	lazy(() => import('modules/CultureCard/pages/CardsList')),
);

const AddCard = Loadable(
	lazy(() => import('modules/CultureCard/pages/AddCard')),
);

const UpdateCard = Loadable(
	lazy(() => import('modules/CultureCard/pages/UpdateCard')),
);

const CULTURE_CARD_ROUTES: IRoute[] = [
	{
		path: 'guides',
		element: GuidesList,
		name: 'GuidesList',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: 'culture-card/categories',
		element: CategoriesList,
		name: 'CategoriesList',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: 'culture-card/cards',
		element: CardsList,
		name: 'CardsList',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: 'culture-card/cards/add',
		element: AddCard,
		name: 'AddCard',
		roles: [ROLES.ADMIN],
		private: true,
	},
	{
		path: 'culture-card/cards/update/:cardId',
		element: UpdateCard,
		name: 'UpdateCard',
		roles: [ROLES.ADMIN],
		private: true,
	},
];

export default CULTURE_CARD_ROUTES;
